import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 24, className = "", as: Tag = "div" }) {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </MotionTag>
  );
}

export function StaggerGroup({ children, className = "", stagger = 0.08 }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      variants={{
        hidden: {},
        show: { transition: { staggerChildren: stagger } },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className = "", y = 24 }) {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y },
        show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionLabel({ id, children, className = "" }) {
  return (
    <div className={`flex items-center gap-3 mb-8 ${className}`}>
      <span className="font-['JetBrains_Mono'] text-[11px] tracking-[0.3em] text-[#00FF66]">
        [{id}]
      </span>
      <span className="h-px flex-1 bg-white/10" />
      <span className="font-['JetBrains_Mono'] text-[11px] tracking-[0.3em] text-[#A1A1AA]">
        {children}
      </span>
    </div>
  );
}
